import React, { useState } from 'react'
import "./LoginForm.css"
import { Container, Spinner} from 'react-bootstrap'
import { Link } from 'react-router-dom'
import axios from 'axios';
import { loginMethod } from '../../hook/auth';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import AlertContainer from '../Alert/Alert';

function LoginForm() {
    const { currentLocal } = useSelector((state) => state.currentLocal);
  const [phone, setphone] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(true)
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch();
  const navigate = useNavigate();
      const [show, setShow] = useState(false);
      const [msg, setMsg] = useState('');
      const [severity, setSeverity] = useState('');


  const saveData = async(e) => {
    e.preventDefault();
    if (!phone || !password) {
      setShow(true)
setMsg('Please Enter All Filed')
setSeverity("error")

    } else {
      setLoading(true)
      await axios
      .post(`https://nanosoft.technology/smile/api/client/auth/login`, {
        phone: phone,
        password:password,
      })
      .then(async (res) => {
      setLoading(false)
        
dispatch(loginMethod({
  data: res.data.data.client,
  access_token: res.data.data.access_token
}))
setShow(true)
setMsg(currentLocal.home.successMessage)
setSeverity("success")
setTimeout(() => {
  setShow(false);
  setMsg("")
          navigate("/");

}, 2000);
})
      .catch((error) => {
  setLoading(false);

  const msg =
    error.response?.data?.errors
      ? Object.values(error.response.data.errors)[0][0]
      : error.response?.data?.message ||
        (currentLocal.language === "العربيه"
          ? "حدث خطأ أثناء تسجيل الدخول، يرجى المحاولة مرة أخرى."
          : "Login failed, please try again.");


setShow(true)
setMsg(msg)
setSeverity("error")



      });

    }

  }
  return (
    <Container>
      {show&&
      <AlertContainer
      msg={msg}
      severity={severity}
      />

      }
      <div className='login_form_container row'>
        <div className='col-md-6 mx-auto mb-4'>
          <h3 className='title mb-2'>
{currentLocal.home.login}
          </h3>
          <form onSubmit={saveData}>
  

            <div className='mb-3'>
              <label className='mb-1'>
                 {currentLocal.home.phone} </label>
              <input
                value={phone}
                onChange={(e) => {
                  setShow(false)
                  setphone(e.target.value)}}

              />
            </div>
              <label className='mb-1'>{currentLocal.home.passwordPlaceholder}</label>

            <div className='mb-2 input_container px-0'>
              <input
                type={showPassword ? 'password' : 'text'}
                value={password}
                onChange={(e) => {
                                    setShow(false)

                  setPassword(e.target.value)}}
                autoComplete='true'
              />
              {showPassword ?
                <button className={currentLocal.language=="English"?'icon_container':"ar_icon_container"} onClick={(e) => {
                  e.preventDefault();
                  setShowPassword(false)
                }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" className="bi bi-eye" viewBox="0 0 16 16">
                    <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                    <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                  </svg>
                </button>
                :
                <button className='icon_container' onClick={(e) => {
                  e.preventDefault();
                  setShowPassword(true)
                }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" className="bi bi-eye-slash" viewBox="0 0 16 16">
                    <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7 7 0 0 0-2.79.588l.77.771A6 6 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755q-.247.248-.517.486z" />
                    <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829" />
                    <path d="M3.35 5.47q-.27.24-.518.487A13 13 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7 7 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12z" />
                  </svg>
                </button>

              }

            </div>
            <div className='w-100 d-flex justify-content-end mb-4'>
              <Link to="/forgetPassword" className='forget_link'>{currentLocal.home.ForgotPassword}</Link>

            </div>

            <button className={loading?'disaactive_login_btn d-flex justify-content-center align-items-center':'login_btn d-flex justify-content-center align-items-center'} type='submit'disabled={loading && true}>
                      {loading &&
                                    <Spinner animation="border" role="status" className='mx-3' size="sm">
                                        <span className="visually-hidden">Loading...</span>
                                    </Spinner>
                                }
                                  <p className='mb-0'>  
              {currentLocal.home.login}
              </p>
            </button>
            <div className='w-100 d-flex justify-content-center my-4'>
            {currentLocal.home.Newcustomer}
              <Link to="/signup" className='forget_link'>{currentLocal.home.Createyouraccount}</Link>

            </div>
              
                
          </form>
        </div>
      </div>
    </Container>
  )
}

export default LoginForm